module.exports = __webpack_public_path__ + "img/btn--facile-v2.b0ed0071.svg";